import { Component, EventEmitter, Input, Output } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-undo',
  templateUrl: './undo.component.html',
  styleUrls: ['./undo.component.scss']
})
export class UndoComponent {
  @Input() undoItem = { message: 'The action', duration: 5 };
  @Output() undoAction = new EventEmitter<any>();

  progressbarValue = 100;
  curSec: number = 0;
  private timerSub?: Subscription;

  ngOnInit(): void {
    // Initialize countdown from input before first change detection to avoid NG0100
    const seconds = Number(this.undoItem?.duration) || 0;
    this.curSec = seconds;
    this.startTimer(seconds);
  }

  startTimer(seconds: number) {
    if (!seconds) { return; }
    const timer$ = interval(1000);
    this.timerSub = timer$.subscribe((sec) => {
      const elapsed = sec + 1;
      this.progressbarValue = Math.max(0, 100 - (elapsed * 100 / seconds));
      this.curSec = Math.max(0, seconds - elapsed);
      if (this.curSec === 0) {
        this.timerSub?.unsubscribe();
      }
    });
  }

  undoActionClk(): void {
    this.undoAction.emit()
  }

  ngOnDestroy(): void {
    this.timerSub?.unsubscribe();
  }
}
